import myIcon from "../assets/my-icon.svg";

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = ({ showSecondSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((s) => !s);
  };

  const location = useLocation();

  const isActive = (path) => {
    // exact match for root, startsWith for other sections (in case of subroutes)
    if (path === "/") return location.pathname === "/";
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  // keep body scroll in sync with menu state
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  // close menu when navigating to a new route to avoid leaving overflow hidden
  useEffect(() => {
    // when location changes, ensure menu is closed
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Mobile Menu Overlay - Moved outside header for full coverage */}
      <div 
        className={`fixed inset-0 glassmorphism z-[100] transition-transform duration-300 lg:hidden ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-10">
          <div className="flex justify-between items-center mb-20">
            <Link to="/" onClick={toggleMenu}>
              <img src={myIcon} alt="my logo" className="w-7" />
            </Link>
            {/* Close button */}
            <button
              className="z-[101] bg-transparent"
              onClick={toggleMenu}
              aria-label="Close menu"
            >
              <svg 
                className="w-6 h-6 text-neutral-100"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>
          <div className="flex flex-col items-start gap-10 font-medium uppercase text-neutral-500 text-2xl">
            <a
              href="/#work"
              className="w-full text-neutral-100 hover:text-neutral-400"
              onClick={toggleMenu}
            >
              Work
            </a>
            <a
              href="/#about"
              className="w-full text-neutral-100 hover:text-neutral-400"
              onClick={toggleMenu}
            >
              About
            </a>
            <a
              href="https://ui.maryojo.me"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-100 hover:text-neutral-400 flex items-center gap-2 w-full"
              onClick={toggleMenu}
            >
              UI Library
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                />
              </svg>
            </a>
            <a
              href="https://blog.maryojo.me"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-100 hover:text-neutral-400 flex items-center gap-2 w-full"
              onClick={toggleMenu}
            >
              Writing
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                />
              </svg>
            </a>
            <Link
              to="/contact"
              className={`w-full hover:text-neutral-400 ${isActive('/contact') ? 'text-[#e3eed1cc]' : 'text-neutral-100'}`}
              onClick={toggleMenu}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`fixed top-0 w-full transition-all duration-300 z-50 nav-style px-10 py-5 ${
          showSecondSection ? "hidden" : "block"
        }`}
      >
        <nav className="relative">
          <div className="flex justify-between items-center">
            <Link to="/">
              <img src={myIcon} alt="my logo" className="w-7" />
            </Link>

            {/* Hamburger Menu Button */}
            <button
              className="lg:hidden relative z-[101] bg-transparent"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <div className="w-6 h-0.5 bg-neutral-400 mb-1.5" />
              <div className="w-6 h-0.5 bg-neutral-400 mb-1.5" />
              <div className="w-6 h-0.5 bg-neutral-400" />
            </button>

            {/* Desktop Menu */}
              <div className="hidden lg:flex gap-7 font-medium uppercase text-neutral-500 text-sm">
              <div><a href="/#work" className="hover:text-neutral-400">Work</a></div>
              <div><a href="/#about" className="hover:text-neutral-400">About</a></div>
              <div className="flex flex-row items-center gap-1">
                <a
                  href="https://ui.maryojo.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-neutral-400"
                >
                  UI Library
                </a>
                <svg
                  className="w-3 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                  />
                </svg>
              </div>
              <div>
                <a
                  href="https://blog.maryojo.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-neutral-400"
                >
                  Writing
                </a>
              </div>
              <div>
                <Link to="/contact" className={`hover:text-neutral-400 ${isActive('/contact') ? 'text-[#e3eed1cc]' : ''}`}>
                Contact
              </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
